var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AchooFilterBoxComponent } from '../../../../core/achoo-filter-box/achoo-filter-box.component';
var AutoGroupFilterBoxComponent = /** @class */ (function (_super) {
    __extends(AutoGroupFilterBoxComponent, _super);
    function AutoGroupFilterBoxComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoGroupFilterBoxComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    return AutoGroupFilterBoxComponent;
}(AchooFilterBoxComponent));
export { AutoGroupFilterBoxComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-filter-box/auto-group-filter-box.component.ts.pre-build-optimizer.js